import {Component, Inject} from '@angular/core';
import {EditionDialogComponent} from "../../../../basic-entity-front/edition-dialog/edition-dialog.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BaseDialogData} from "../../../../basic-entity-front/basic-entity-table/base-dialog-data";
import {ApiModuleFactory} from "../../../../api/api-module-factory.service";
import {InterfaceProviderService} from "../../../../basic-entity-back/services/interface-provider.service";
import {UntypedFormBuilder} from "@angular/forms";
import {ErrorDisplayService} from "../../../../basic-entity-front/services/error-display.service";
import {ClienteAsociado} from "../../../../model/personas/cliente-asociado.model";

/**
 * Diálogo de edición del asociado. Las direcciones (pestaña "Direcciones") son ahora una propiedad
 * anidada escribible más del modelo -exactamente igual que Persona.direcciones-, así que el
 * `be-edition-tab` genérico ya se encarga de su alta/edición/borrado dentro del propio formGroup;
 * no hace falta código propio aquí para eso.
 */
@Component({
    selector: 'app-asociados-edition',
    templateUrl: './asociados-edition.component.html',
    styleUrls: ['./asociados-edition.component.scss']
})
export class AsociadosEditionComponent extends EditionDialogComponent<ClienteAsociado> {

    constructor(@Inject(MAT_DIALOG_DATA) private data: BaseDialogData<ClienteAsociado>, private dialogRef: MatDialogRef<EditionDialogComponent<ClienteAsociado>>,
                apiFactory: ApiModuleFactory, public interfaceProvider: InterfaceProviderService, fb: UntypedFormBuilder, private _myErrorDisplay: ErrorDisplayService) {
        super(data, dialogRef, apiFactory, interfaceProvider, fb, _myErrorDisplay);
        data.shouldManageSaving = true;
    }

    ngOnInit() {
    }
}
